import { Button, Calendar, Divider, Flex, Select, Skeleton } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import "./style.css";
import dayjs from 'dayjs';
import API from 'API';
import { formatScore, getAllDaysInMonth } from 'general_function';
import { CaretLeftOutlined, CaretRightOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { theme } from 'antd';
import TestModal, { considerStatus, STATUS } from './TestModal';
import { useNavigate } from 'react-router-dom';
const { useToken } = theme;

const months = Array.from({ length: 12 }, (_, i) => `Tháng ${i + 1}`);
const startYear = 2025;
const NOW = dayjs();
const currentYear = NOW.year();
const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => currentYear + i);

function DateCell({ date, events, now, setChosenEvent }) {
    const navigate = useNavigate();
    if (!(`${date.date()}/${date.month()}` in events)) {
        return <></>
    }

    return events[`${date.date()}/${date.month()}`].map(event => {
        if (event.type === "exam") {
            return <React.Fragment key={event.release}>
                <div className={`date-cell-event during`}>
                    <b>Thi cuối kỳ</b><br />
                    <div style={{ color: "rgb(102 102 102)", fontSize: 12, fontStyle: "italic" }}>
                        {event.course_name}
                    </div>
                    <div style={{ color: "rgb(102 102 102)", fontSize: 12, fontWeight: "bold" }}>
                        {event.final_exam_time.format("HH:mm:ss")}
                    </div>
                    <div style={{ color: "rgb(102 102 102)", fontSize: 12, fontWeight: "bold" }}>
                        {event.term_title}
                    </div>
                </div>
            </React.Fragment>
        }
        const status = considerStatus(event, now);
        const status_text = STATUS[status];
        return <React.Fragment key={event.release}><div className={`date-cell-event ${status_text}`} id={`release-${event.release}`}
            onClick={()=>setChosenEvent(event)}
        >
            {event.result !== null ? <div className='score' style={{
                backgroundColor: event.result < 500 ? "rgb(255, 138, 138)" : 
                event.result < 700 ? "rgb(220, 255, 113)" : "rgb(180, 255, 180)"
            }}>
                {formatScore(event.result)}
            </div> : status === 1 ? <div className='score' style={{
                backgroundColor: "rgb(138, 212, 255)"
            }}>
                <ExclamationCircleFilled style={{ color: "rgb(15, 121, 182)"}}/>
            </div> : <></>}
            {status === 1 && <div>
                <Button type='link' onClick={()=>navigate(`/student-test/${event.id}`)}>
                    Vào làm bài
                </Button>
            </div>}
            {status === 2 && <div style={{ color: "red", fontStyle: "italic"}}>
                Bạn đã bỏ bài thi này
            </div>}
            <div>{event.title}</div>
            <div style={{ color: "rgb(102 102 102)", fontSize: 12, fontStyle: "italic" }}>
                {event.course_name}
            </div>
            <div style={{ color: "rgb(102 102 102)", fontSize: 12, fontWeight: "bold" }}>
                {event.show_start_time.format("HH:mm:ss")} - {event.show_end_time.format("HH:mm:ss")}
            </div>
            <div style={{ color: "rgb(102 102 102)", fontSize: 12, fontWeight: "bold" }}>
                Số lần làm bài: {event.done}/{event.limit}<br />
            </div>
        </div>
            <Divider style={{ margin: 5, minWidth: "unset", width: "90%" }} />
        </React.Fragment>
    })
}

export default function StudentCalendar() {
    const [now, setNow] = useState(NOW);
    useEffect(() => {
        const internal = setInterval(() => { setNow(dayjs()); }, 60000);
        return () => clearInterval(internal);
    }, [])
    const [date, setDate] = useState(NOW);
    const [testReleases, setTestReleases] = useState({});
    const [courseTermInfos, setCourseTermInfos] = useState({});
    const [gettingTestRelease, setGettingTestRelease] = useState(false);
    const [gettingCourseTermInfo, setGettingCourseTermInfo] = useState(false);
    const [chosenEvent, setChosenEvent] = useState(null);
    const { token } = useToken();

    useEffect(() => {
        async function fetchData() {
            try {
                setGettingTestRelease(true);
                const response = await API.get("/student/test-releases/", {
                    params: {
                        page_size: 1000,
                        start_date: date.clone().startOf("month").format("YYYY-MM-DD"),
                        end_date: date.clone().endOf("month").format("YYYY-MM-DD"),
                    }
                })
                const data = response.data.results.map(item => ({
                    ...item,
                    start_time: dayjs(item.start_time),
                    end_time: dayjs(item.end_time)
                }))
                const daysInMonth = getAllDaysInMonth(date);
                const events = {};
                for (const day of daysInMonth) {
                    const events_in_date = [];
                    for (const d of data) {
                        if (d.end_time.isBefore(day, "day") || d.start_time.isAfter(day, "day")) {
                            continue;
                        }
                        const event = { ...d, testType: d.type, type: "test" };
                        if (event.start_time.isBefore(day, "day")) {
                            event.show_start_time = day.clone().startOf("day");
                        } else {
                            event.show_start_time = event.start_time;
                        }
                        if (event.end_time.isAfter(day, "day")) {
                            event.show_end_time = day.clone().endOf("day");
                        } else {
                            event.show_end_time = event.end_time;
                        }
                        events_in_date.push(event);
                    }
                    if (events_in_date.length) {
                        events[`${day.date()}/${day.month()}`] = events_in_date;
                    }
                }
                setTestReleases(events);
            } catch (e) {
                console.log(e);
            }
            setGettingTestRelease(false);
        }
        fetchData();
    // eslint-disable-next-line
    }, [date.month(), date.year()])

    useEffect(() => {
        async function fetchData() {
            try {
                setGettingCourseTermInfo(true);
                const response = await API.get("/student/course-term-info/", {
                    params: {
                        page_size: 1000,
                        start_date: date.clone().startOf("month").format("YYYY-MM-DD"),
                        end_date: date.clone().endOf("month").format("YYYY-MM-DD"),
                    }
                })
                const data = response.data.results.map(item => ({
                    ...item,
                    final_exam_time: dayjs(item.final_exam_time),
                }))
                const daysInMonth = getAllDaysInMonth(date);
                const events = {};
                for (const day of daysInMonth) {
                    const events_in_date = [];
                    for (const d of data) {
                        if (d.final_exam_time.startOf('day').isSame(day)) {
                            events_in_date.push({ ...d, type: "exam" });
                        }
                    }
                    if (events_in_date.length) {
                        events[`${day.date()}/${day.month()}`] = events_in_date;
                    }
                }
                setCourseTermInfos(events);
            } catch (e) {
                console.log(e);
            }
            setGettingCourseTermInfo(false);
        }
        fetchData();
    // eslint-disable-next-line
    }, [date.month(), date.year()])

    const handleYearChange = (newYear) => {
        const newValue = date.clone().year(newYear);
        setDate(newValue);
    };

    const handleMonthChange = (newMonth) => {
        const newValue = date.clone().month(newMonth);
        setDate(newValue);
    };


    const events = useMemo(() => {
        const result = {};
        for (const key in testReleases) {
            result[key] = courseTermInfos[key] ? [...courseTermInfos[key], ...testReleases[key]] : testReleases[key];
        }

        for (const key in courseTermInfos) {
            if (key in result) continue;
            result[key] = testReleases[key] ? [...courseTermInfos[key], ...testReleases[key]] : courseTermInfos[key];
        }
        return result;
    },[testReleases, courseTermInfos]);

    return <>
        <Flex align="center" style={{ marginBottom: 8 }}>
            <Button style={{ padding: 5, marginRight: 3 }} onClick={() => setDate(date.subtract(1, "month"))}>
                <CaretLeftOutlined style={{ fontSize: 25, color: token.colorPrimary }} />
            </Button>
            <Select
                value={date.year()}
                onChange={handleYearChange}
                options={years.map((y) => ({ label: y, value: y }))}
                style={{ width: 100,  color: token.colorPrimary }}
            />
            <Select
                value={date.month()}
                onChange={handleMonthChange}
                options={months.map((m, i) => ({ label: m, value: i }))}
                style={{ width: 120,  color: token.colorPrimary }}
            />
            <Button style={{ padding: 5, marginLeft: 3 }} onClick={() => setDate(date.add(1, "month"))}>
                <CaretRightOutlined style={{ fontSize: 25, color: token.colorPrimary }} />
            </Button>
            {(date.month() !== now.month() || date.year() !== now.year()) && <Button type="primary"
                style={{ marginLeft: 3 }} onClick={() => setDate(now)}
            >
                Tháng này
            </Button>}
        </Flex>
        {/* <div style={{ marginBottom: 10 }}>

        </div> */}
        {gettingTestRelease || gettingCourseTermInfo ? <Skeleton active /> : 
        <div style={{ overflowX: "auto" }}>
            <Calendar
                className='student-calendar'
                headerRender={() => null}
                value={date}
                mode="month" cellRender={(current) => <DateCell date={current} events={events} now={now} setChosenEvent={setChosenEvent}/>} onChange={value => {
                    setDate(value);
                }}
            />
        </div>
        }
        <TestModal event={chosenEvent} setEvent={setChosenEvent} now={now} />
    </>
}
